import { KPIRepository } from '@/core/repositories/kpi.repository'
import { KPIGetListResponseT, KPIGetParamsT, ReportGetListResponseT } from '../types/kpi.types'

const kpiRepository = new KPIRepository()

export class KPIService {
    async getDeliveryList(params: KPIGetParamsT): Promise<KPIGetListResponseT> {
        const response = await kpiRepository.getDeliveryList(params)
        return response.data
    }

    async getTelephonyList(params: KPIGetParamsT): Promise<KPIGetListResponseT> {
        const response = await kpiRepository.getTelephonyList(params)
        return response.data
    }

    async uploadDeliveryFile(form_data: FormData): Promise<void> {
        await kpiRepository.uploadDeliveryFile(form_data)
    }

    async uploadTelephonyFile(form_data: FormData): Promise<void> {
        await kpiRepository.uploadTelephonyFile(form_data)
    }

    async getReport(form_data: FormData): Promise<ReportGetListResponseT> {
        const response = await kpiRepository.getReport(form_data)
        return response.data
    }
}
